import type { AssessmentResultV2 } from '../types';

type PatientIdentifierSource = {
  personalData?: {
    cpf?: string | null;
    rg?: string | null;
  } | null;
  patientCpf?: string | null;
  patientRg?: string | null;
  cpf?: string | null;
  rg?: string | null;
} | null;

export const normalizePatientIdentifier = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const getPreferredPatientIdentifier = (source?: PatientIdentifierSource): string | null =>
  normalizePatientIdentifier(source?.personalData?.cpf) ??
  normalizePatientIdentifier(source?.patientCpf) ??
  normalizePatientIdentifier(source?.cpf) ??
  normalizePatientIdentifier(source?.personalData?.rg) ??
  normalizePatientIdentifier(source?.patientRg) ??
  normalizePatientIdentifier(source?.rg) ??
  null;

export const getAssessmentResultIdentifier = (
  result?: Pick<AssessmentResultV2, 'patientMedicalRecordSnapshot' | 'payloadJson'> | null,
): string | null => {
  const payloadJson =
    result?.payloadJson && typeof result.payloadJson === 'object' && !Array.isArray(result.payloadJson)
      ? result.payloadJson
      : null;
  const patientContext =
    payloadJson?.patientContext && typeof payloadJson.patientContext === 'object' && !Array.isArray(payloadJson.patientContext)
      ? (payloadJson.patientContext as Record<string, unknown>)
      : null;

  return normalizePatientIdentifier(patientContext?.identifier) ?? normalizePatientIdentifier(result?.patientMedicalRecordSnapshot) ?? null;
};
